import React from 'react';

export default function AppFooter() {
  return (
    <footer
      className="border-t-2 border-foreground mt-auto"
      style={{ backgroundColor: 'var(--foreground)' }}
    >
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Brand */}
          <div>
            <h3
              className="font-heading text-lg tracking-stamp mb-2"
              style={{ color: 'var(--background)', fontFamily: 'var(--font-heading)' }}
            >
              CLEARANCE CONNECT
            </h3>
            <p className="text-sm" style={{ color: 'var(--muted)' }}>
              Clear Deadstock. Unlock Value.
            </p>
            <p className="text-xs mt-2 font-mono-data" style={{ color: 'var(--steel)', fontFamily: 'var(--font-mono)' }}>
              rajesh@clearanceconnect.com
            </p>
          </div>

          {/* Company */}
          <div>
            <h4
              className="font-heading text-xs tracking-stamp mb-2"
              style={{ color: 'var(--muted)', fontFamily: 'var(--font-heading)' }}
            >
              COMPANY
            </h4>
            <p className="text-sm" style={{ color: 'var(--background)' }}>
              Trivolt Tech Private Limited
            </p>
            <p className="text-xs font-mono-data mt-1" style={{ color: 'var(--muted)', fontFamily: 'var(--font-mono)' }}>
              CIN: U43210KA2023PTC181911
            </p>
            <p className="text-xs mt-1" style={{ color: 'var(--muted)' }}>
              Bengaluru, Karnataka, India
            </p>
          </div>

          {/* Event */}
          <div>
            <h4
              className="font-heading text-xs tracking-stamp mb-2"
              style={{ color: 'var(--muted)', fontFamily: 'var(--font-heading)' }}
            >
              RECOGNITION
            </h4>
            <div
              className="inline-flex items-center gap-2 px-3 py-2 border"
              style={{ borderColor: 'var(--primary)', borderStyle: 'dashed' }}
            >
              <span
                className="font-heading text-sm tracking-wide"
                style={{ color: 'var(--primary)', fontFamily: 'var(--font-heading)' }}
              >
                ELEVATE 2026
              </span>
            </div>
            <p className="text-xs mt-2" style={{ color: 'var(--muted)' }}>
              Karnataka Startup Cell
            </p>
          </div>
        </div>

        <div
          className="border-t mt-6 pt-4 flex flex-col md:flex-row items-center justify-between gap-2"
          style={{ borderColor: 'var(--steel)' }}
        >
          <p className="text-xs font-mono-data" style={{ color: 'var(--muted)', fontFamily: 'var(--font-mono)' }}>
            © 2026 Trivolt Tech Private Limited. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <p className="text-xs" style={{ color: 'var(--steel)' }}>
              B2B & B2C Deadstock Clearance Platform · India
            </p>
            <span style={{ color: 'var(--steel)' }}>·</span>
            <a
              href="/admin/login"
              className="text-xs hover:underline"
              style={{ color: 'var(--steel)' }}
            >
              Admin Portal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
